import { render, staticRenderFns } from "./LikeDefaultLayout.vue?vue&type=template&id=6d66afc6&scoped=true"
import script from "./LikeDefaultLayout.vue?vue&type=script&lang=js"
export * from "./LikeDefaultLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d66afc6",
  null
  
)

export default component.exports